const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const NUMBER_REGEX = /^[0-9\b]+$/;
const PERMISSION_NAME_REGEX = /^[a-z]+:[a-z:]*[a-z]+$/;
const NAME_REGEX = /^[a-zA-Z\s]+$/;

export { EMAIL_REGEX, NUMBER_REGEX, PERMISSION_NAME_REGEX, NAME_REGEX };
